// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseButton_close__qe2hU"};